'use strict';

const {
    extendBookingDetailSegments,
    TRACKING,
    CSS_CLASSES,
} = require('./utils/constans');

const trackingUtils = require('od-modules/utils/tracking.utils');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const BaseView = require('components-framework/view/base.view');


module.exports = withCachedSelectors(BaseView.extend({
    templateSettings: {
        evaluate: /\{\{#([\s\S]+?)\}\}/g,
        interpolate: /\{\{[^#{]([\s\S]+?)[^}]\}\}/g,
        escape: /\{\{\{([\s\S]+?)\}\}\}/g,
    },
    selectors: {
        bookingItineraryContainer: '.itinerary_',
        itineraryDetailsSegments: '.itinerary_details_segments',
        scheduleColor: '.schedule_color',
        scheduleIcon: '.schedule_icon',
        scheduleText: '.schedule_text',
        cancelledText: '.cancelled_text',
        segmentsItineraryBox: '.segments_itinerary_box',
    },
    events: {
        'tap .flight_status_more_info': 'onItineraryDetailsAlteredMoreInfo',
        'tap .contextual_offer_open_btn': 'openProductDeepLink',
        'tap .contextual_offer_open_ban': 'openProductDeepLink',
    },
    xsellModule: null,

    initialize({data}) {
        extendBookingDetailSegments(data.bookingDetail);
        this.model.set(data);
        this.$el.html(this.templates.itineraryDetails({
            ...this.model.getData(),
            ...{
                templates: this.templates,
                translations: this.keys,
            },
        }));
    },

    onItineraryDetailsAlteredMoreInfo() {
        Odigeo.Utils.scrollToElement($('body'));
        const trackingInfo = this.model.get('trackingInfo');
        const label = trackingUtils.composeLabel(TRACKING.ITINERARY_MORE_INFO_PREFIX, TRACKING.ITINERARY_MORE_INFO_PARAMS, trackingInfo);
        trackingUtils.trackEvent(TRACKING.CANCELLATION_ACTION, label);
    },

    openProductDeepLink({currentTarget: {dataset = {}, className = ''}}) {
        const {product, segmentIndex} = dataset;
        const eventAction = className.replace(/.*contextual_offer_([^\s]*).*/, '$1');
        this.trackContextualOfferEvent(eventAction, product, parseInt(segmentIndex, 10));

        const isBtn = eventAction === 'open_btn';
        this.openDeepLink(product, isBtn);
    },

    loadXSELLModule({controller, bookingData, el, isAutomaticRedirection}) {
        this.xsellModule = controller();
        this.xsellModule.setItinerary(bookingData);
        this.xsellModule.setContainer(el);
        this.xsellModule.setIsRedirection(isAutomaticRedirection);
        this.xsellModule.renderCrosssellPageWidgets();
    },

    openDeepLink(product, isBtn) {
        switch (product) {
            case 'car':
                this.xsellModule.openCarsDeepLink(isBtn ?
                    this.xsellModule.touchpoints.mytripdetails_cars_itinerary_textlink :
                    this.xsellModule.touchpoints.mytripdetails_cars_itinerary_banner
                );
                break;
            case 'hotel':
                this.xsellModule.openHotelsDeepLink(this.xsellModule.touchpoints.mytripsdetails_hotels_itinerary_textlink);
                break;
            case 'transfer':
                this.xsellModule.openGtDeepLink(this.xsellModule.touchpoints.mytripsdetails_gt_itinerary_textlink);
                break;
            case 'activities':
                this.xsellModule.openActivitiesDeepLink(isBtn ?
                    this.xsellModule.touchpoints.mytripdetails_gyg_itinerary_textlink :
                    this.xsellModule.touchpoints.mytripdetails_gyg_itinerary_banner
                );
                break;
        }
    },

    trackContextualOfferEvent(event, product, segmentIndex) {
        const {bookingBasicInfo, itineraryBookings, travellers} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
        const bookingId = Odigeo._.get(bookingBasicInfo, 'id');
        const tripTypeAbbr = Odigeo._.get(itineraryBookings, 'bookingItinerary.tripType', '')
            .split('_')
            .map((s) => s.charAt(0))
            .join('')
            .replace('S', 'D');
        const numSegments = Odigeo._.get(itineraryBookings, 'itinerarySegments.length');
        const label = `${event}:${product}_type:${tripTypeAbbr}_pax:${travellers.length}_totleg:${numSegments}_leg:${++segmentIndex}_id:${bookingId}`;
        trackingUtils.trackEventWithCategory(TRACKING.TRIP_DETAILS_CATEGORY, TRACKING.WIDGET_SUMMARY_ACTION, label);
    },

    // TODO: Is not necessary in isBookingImportantMessage
    updateItineraryScheduleChanges({scheduleChangesPNRs, cancelledPNRs}) {
        const uniqueSegments = Odigeo._.chain(scheduleChangesPNRs).values().map('sectionsIndex').flatten().uniq().value();

        uniqueSegments.forEach((segmentIndex) => {
            const schedulePNRsInSegment = Odigeo._.pick(scheduleChangesPNRs, (pnrInfo) => pnrInfo.sectionsIndex.includes(segmentIndex));
            const cancelledPNRsInSegment = Odigeo._.pick(cancelledPNRs, (pnrInfo) => pnrInfo.sectionsIndex.includes(segmentIndex));
            const segmentToUpdate = this.$el.find(this.selectors.itineraryDetailsSegments).find('[data-segment-index="' + segmentIndex + '"]');

            if (Odigeo.Utils.isMobile() ||
                (Odigeo.Utils.isDesktop() && Object.keys(schedulePNRsInSegment).length === Object.keys(cancelledPNRsInSegment).length)) {
                this.renderSegment(segmentToUpdate);
            }
        });
    },

    // TODO: Is not necessary in isBookingImportantMessage and clean selectors too
    renderSegment(segmentToUpdate) {
        segmentToUpdate.find(this.selectors.scheduleText).removeClass(CSS_CLASSES.ODF_HIDDEN);
        segmentToUpdate.find(this.selectors.cancelledText).addClass(CSS_CLASSES.ODF_HIDDEN);
        if (Odigeo.Utils.isDesktop()) {
            segmentToUpdate.find(this.selectors.scheduleIcon).removeClass(CSS_CLASSES.ODF_ICON_2XL);
            segmentToUpdate.find(this.selectors.scheduleIcon).removeClass(CSS_CLASSES.ODF_INLINE_MIDDLE);
        }
    },

    // TODO: Is not necessary in isBookingImportantMessage
    showSegmentsItineraryBox() {
        this.$cachedSelectors.segmentsItineraryBox.removeClass(CSS_CLASSES.ODF_HIDDEN);
    },
}));
